import React from "react";
import Footerdeo from "../shared/Footerdeo";
import Navbardeo from "../shared/Navbardeo";
import Sidebardeo from "../shared/Sidebardeo";

function Initiateverification() {
  return (
    <>
      <div class="container-scroller">
        <Navbardeo />
        <div class="container-fluid page-body-wrapper">
          <Sidebardeo />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <div class="row">
                    <div class="col-12 col-xl-12 mb-4 mb-xl-0">
                      <h3
                        class="font-weight-bold"
                        style={{ textTransform: "uppercase" }}
                      >
                        Welcome DEO
                      </h3>
                      <h6
                        class="font-weight-normal mb-2"
                        style={{ textTransform: "uppercase" }}
                      >
                        District - BOKARO, JHARKHAND
                      </h6>
                      {/* <h6 class="font-weight-normal mb-0">
                        A S T V S ZILA VIDYALAYA RANCHI , RANCHI
                      </h6> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <table className="table table-condensed table-striped table-bordered">
                        <thead>
                            <tr>
                                <td colSpan="12">Student Details</td>
                                <td colSpan="8">Communication Details</td>
                                <td colSpan="9">Educational Details</td>
                            </tr>
                          <tr>
                            <th><input type="checkbox" /></th>
                            <th>Sl No.</th>
                            <th>Name of Candidate</th>
                            <th>Gender</th>
                            <th>Date of Birth</th>
                            <th>Father’s Name</th>
                            <th>Mother’s Name</th>
                            <th>Religion</th>
                            <th>Nationality</th>
                            <th>Aadhaar Number	</th>
                            <th>Divyang</th>
                            <th>Caste</th>
                            <th>Area</th>
                            <th>State</th>
                            <th>District</th>
                            <th>Block</th>
                            <th>Address</th>
                            <th>Pin</th>
                            <th>Student Contact Number</th>
                            <th>Email ID</th>
                            <th>Category</th>
                            <th>Medium of Examination</th>
                            <th>Board</th>
                            <th>Language I Subject</th>
                            <th>Language II Subject</th>
                            <th>Compulsory I Subject</th>
                            <th>Compulsory II Subject</th>
                            <th>Compulsory III Subject</th>
                            <th>Additional Subject</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footerdeo />
          </div>
        </div>
      </div>
    </>
  );
}

export default Initiateverification;
